<template>
    <div>
        <div class="filter-bar">
            <el-row :gutter="12">
                <el-col :xs="24" :sm="12" :md="8" :lg="6">
                    <el-select
                        v-model="form.status"
                        placeholder="Chọn trạng thái"
                        clearable
                        style="width: 200px;"
                        @change="getTaskByCustomer"
                    >
                        <el-option
                            v-for="item in listStatusTask"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                </el-col>

            </el-row>
        </div>

        <el-table :data="tableData" style="width: 100%" :loading="loading">
            <el-table-column prop="id" label="ID" />
            <el-table-column prop="customer.name" label="Tên Khách hàng" />
            <el-table-column prop="created_user.name" label="Người tạo task" />
            <el-table-column label="Trạng thái">
                <template v-slot="scope">

                    <el-button
                        :type="taskMeta(scope.row.status).type"
                        size="mini"
                    >
                        {{ taskMeta(scope.row.status).label }}
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column label="Thời gian tạo">
                <template v-slot="scope">
                    {{ scope.row.created_at | formatDate }}
                </template>
            </el-table-column>

            <el-table-column label="Deadline">
                <template v-slot="scope">
                    {{ scope.row.deadline | formatDateTime }}
                </template>
            </el-table-column>
            <el-table-column label="Hành động" width="190">
                <template v-slot="scope">
                    <el-tooltip content="Sửa nội dung task" placement="top">
                        <button
                            @click="showDialogUpdateTaskContent(scope.row);"
                            class="btn btn-info btn-sm btn-icon waves-effect waves-themed mr-2 text-center"
                        >
                            <i class="el-icon-edit"></i>
                        </button>
                    </el-tooltip>
                    <el-tooltip content="Chuyển trạng thái pendding" placement="top">
                        <button
                            @click="changeStatusTask(scope.row,2)"
                            class="btn btn-warning btn-sm btn-icon waves-effect waves-themed mr-2 text-center"
                        >
                            <i class="fas fa-diagnoses"></i>
                        </button>
                    </el-tooltip>

                    <el-tooltip content="Chuyển trạng thái done" placement="top">
                        <button
                            @click="changeStatusTask(scope.row, 3)"
                            class="btn btn-success btn-sm btn-icon waves-effect waves-themed mr-2 text-center"
                        >
                            <i class="fa fa-check"></i>
                        </button>
                    </el-tooltip>
                    <el-tooltip content="Xem chi tiết" placement="top">
                        <button
                            @click="showDetailTask(scope.row)"
                            class="btn btn-primary btn-sm btn-icon waves-effect waves-themed mr-2 text-center"
                        >
                            <i class="fa fa-eye"></i>
                        </button>
                    </el-tooltip>

                    <el-tooltip v-if="!scope.row.result" content="Nhập thành phẩm" placement="top" >
                        <button
                            @click="showDialogInputResults(scope.row); close()"
                            class="btn btn-info btn-sm btn-icon waves-effect waves-themed mr-2 text-center"
                        >
                            <i class="fa fa-pencil"></i>
                        </button>
                    </el-tooltip>

                    <el-tooltip v-if="scope.row.result" content="Sửa thành phẩm" placement="top">
                        <button
                            @click="showDialogInputResults(scope.row); close()"
                            class="btn btn-info btn-sm btn-icon waves-effect waves-themed mr-2 text-center"
                        >
                            <i class="el-icon-edit-outline"></i>
                        </button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>

        <!-- Phân trang -->
        <div class="mt-3" style="display:flex; justify-content:center;">
            <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page.sync="paging.current_page"
                :page-size="paging.per_page"
                layout="prev, pager, next"
                :total="paging.total"
            />
        </div>

        <el-dialog
            title="Sửa nội dung task"
            width="60%"
            class="responsive"
            append-to-body
            :visible.sync="dialogUpdateContentTaskVisible"
        >
        <update-content-task :is_show="dialogUpdateContentTaskVisible" :task="taskSelect" @close="dialogUpdateContentTaskVisible=false; close()" />
        </el-dialog>

        <el-dialog
            title="Chi tiết task"
            :visible.sync="dialogDetailTask"
            width="70%"
            append-to-body
            class="task-detail-dialog"
            :show-close="false"
        >
            <div class="task-detail-wrapper">
                <div class="task-detail-label">Nội dung công việc:</div>

                <div class="task-detail-box" style="min-height: 10vh; max-height: 20vh" v-html="taskDetailHtml"></div>
            </div>

            <div v-if="taskSelect.result" class="task-detail-wrapper mt-5">
                <div class="task-detail-label">Nội dung thành phẩm:</div>

                <div class="task-detail-box" style="min-height: 10vh; max-height: 20vh" v-html="taskSelect.result"></div>
            </div>

            <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogDetailTask = false">Hủy</el-button>
        </span>
        </el-dialog>

        <el-dialog
            title="Báo cáo tiến độ công việc"
            :visible.sync="dialogInputResult"
            width="70%"
            append-to-body
            class="task-detail-dialog"
            :show-close="false"
        >
        <create-input-result :task="taskSelect" :is_show="dialogInputResult" @close="dialogInputResult=false"></create-input-result>
        </el-dialog>
    </div>


</template>

<script>
import {GET_TASK_WITH_CUSTOMER, CHANGE_STATUS_TASK, CREATE_INPUT_RESULT_TASK} from "@/core/services/store/customer/customer.module";

import debounce from "lodash/debounce";
import CreateInputResult from "../task/compoment/createInputResultDialog.vue";
import {mapGetters} from "vuex";
import UpdateContentTask from "../task/compoment/updateContentTask.vue";

export default {
    name: 'DialogHandleTask',
    components: {UpdateContentTask, CreateInputResult},
    props: {
        is_show: { type: Boolean, default: false },
        customer: { type: Object, default: {} },
    },
    data() {
        return {
            form: {
                status: '',
            },
            task_content: '',
            tableData: [],
            paging: {
                current_page: 1,
                per_page: 5,
                total: 0,
            },
            task_meta: {
                1: { type: 'info',  label: 'Chưa xử lý' },
                2: { type: 'warning', label: 'Đang xử lý' },
                3: { type: 'success', label: 'Hoàn thành' },
            },
            listStatusTask: [
                { label: 'Chưa xử lý', value: 1 },
                { label: 'Đang xử lý', value: 2 },
                { label: 'Hoàn thành', value: 3 },
            ],

            dialogUpdateContentTaskVisible: false,
            loading: false,
            debouncedSearch: null,
            taskDetail: '',
            taskSelect: '',
            dialogDetailTask: false,
            dialogInputResult: false,
        }
    },
    created() {
        this.debouncedSearch = debounce(this.getTaskByCustomer, 400)
    },
    computed: {
        ...mapGetters(['keyAccount','currentUser']),
        taskDetailHtml() {
            if (!this.taskDetail) return '';
            return this.taskDetail.replace(/\n/g, '<br>');
        },

        isDisabled() {
            return !(this.task_content.trim());
        }
    },

    watch: {
        is_show: {
            immediate: true,
            handler (val) {
                if (val) {
                    this.getTaskByCustomer()
                }else {
                    this.tableData = [];
                    this.form.status = '';
                    this.paging.current_page = 1
                }
            }
        }
    },
    methods: {
        changeStatusTask(item, type) {
            const payload = {
                customer_id: item.customer_id,
                task_id: item.id,
                status: type,
            };
            this.$store.dispatch(CHANGE_STATUS_TASK, payload)
                .then((res) => {
                    if (res.status === 422) {
                        this.$message({type: 'warning', message: `${res.message}`, showClose: true})
                        return
                    }
                    const taskId   = res.data.task_id || payload.task_id;
                    const taskType = res.data.status;
                    this.tableData = this.tableData.map(item => {
                        if (item.id === taskId) {
                            return {
                                ...item,
                                status: taskType,
                            };
                        }
                        return item;
                    });

                    this.$notify({
                        title: 'Thành công!',
                        message: `${res.message}`,
                        type: 'success'
                    });
                    this.$emit('update-type-task-customer', res.data)
                });
        },

        getTaskByCustomer() {
            if(!this.customer.id) return;
            const payload = {
                customer_id: this.customer.id,
                status: this.form.status
            };
            this.$store.dispatch(GET_TASK_WITH_CUSTOMER, payload)
                .then((res) => {
                if (res.status === 422) {
                    this.$message({type: 'warning', message: `${res.message}`, showClose: true})
                    return
                }
                this.tableData = res.data.data;
                this.paging.total = Number(res.data.total ?? 0)
                this.paging.per_page = Number(res.data.per_page ?? 0)
                this.paging.current_page = Number(res.data.current_page ?? 0)
            });
        },

        showDialogInputResults(item) {
            this.taskSelect = item;
            this.dialogInputResult = true;
        },

        handleCurrentChange(page) {
            this.paging.current_page = page
            this.getTaskByCustomer()
        },

        taskMeta(status) {
            return this.task_meta[status] || this.default_meta;
        },

        showDetailTask(item) {
            this.taskDetail = item.task_content;
            this.taskSelect = item;
            this.dialogDetailTask = true;
        },

        showDialogUpdateTaskContent(item){
            this.taskSelect = item;
            this.dialogUpdateContentTaskVisible = true;
        },

        close() {
            this.$emit('close');
        }
    },
}
</script>

<style>
.task-detail-wrapper {
    margin-top: 4px;
}

.task-detail-label {
    font-size: 13px;
    font-weight: 600;
    color: #606266;
    margin-bottom: 6px;
}

.task-detail-box {
    background: rgb(238 240 245);
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 14px;
    line-height: 1.6;
    color: #303133;

    max-height: 220px;   /* giới hạn chiều cao */
    overflow-y: auto;    /* nội dung dài sẽ có scroll dọc */
}

.task-detail-box::-webkit-scrollbar {
    width: 6px;
}

.task-detail-box::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #c0c4cc;
}
</style>




